export default "__VITE_ASSET__DpmKIXTR__"